import './navigation.scss'
import React from 'react'
import { useSsr } from '../../hooks/SSR/useSsr'
import { getLinkPathname } from './helper'
import { Link } from '../global'

const NavigationLinks = ({ navItem }) => {
  const isServerSideRendered = useSsr()

  if (isServerSideRendered) return null

  const pathname = typeof window !== 'undefined' && window.location?.pathname
  const childItem = navItem.childItems.nodes.find(
    item => getLinkPathname(item) === pathname,
  )
    ? true
    : false

  const isActiveLink = getLinkPathname(navItem) === pathname || childItem

  const render = () => {
    if (!navItem.parentId) {
      return (
        <Link
          className={`nav__ul-item nav-link${
            (isActiveLink && '__active') || ''
          }`}
          key={navItem.id}
          to={navItem.path}
        >
          {navItem.label}
        </Link>
      )
    }
  }
  return <>{render()}</>
}

export default NavigationLinks
